import type { FC } from "react";

import { useTextSeparatorWithDirectionalMark } from "@ui/hooks/useTextSeparatorWithDirectionalMark";

import type { Address } from "@jti/fe-common";

type AddressStreetInfoUnitedArabEmiratesProps = Partial<Address>;

export const AddressStreetInfoUnitedArabEmirates: FC<AddressStreetInfoUnitedArabEmiratesProps> = ({
  city,
  premise,
  landmark,
  streetName,
  streetAdditional,
  neighborhood,
}) => {
  const { joinWithSeparator } = useTextSeparatorWithDirectionalMark();

  const firstRow = joinWithSeparator(streetAdditional, premise);
  const secondRow = joinWithSeparator(streetName, neighborhood, city);

  return (
    <>
      <div>{firstRow}</div>
      <div>{secondRow}</div>
      {landmark && <div>{landmark}</div>}
    </>
  );
};
